var account = "Konto";
var accountSettings = "Kontoinställningar";
var charging = "Laddning";
var contactInfo = "Kontaktuppgifter";
var dashboard = "Instrumentpanel";
var home = "Hem";
var myProducts = "Mina produkter";
var orderHistory = "Beställningshistorik";
var paymentMethod = "Betalning";
var profileSettings = "Profilinställningar";
var referAndEarn = "Värva och belönas";
var signOut = "Logga ut";
var sv_SE = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, sv_SE as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
